import { StreamActions } from "@hotwired/turbo"

StreamActions.alert = function() {
  const message = this.getAttribute("message")
  alert(message)
}

StreamActions.close_tooltips = function() {
  $('.tooltip').tooltip('hide');
}

StreamActions.window_open = function() {
  const url = this.getAttribute("url")
  const target = this.getAttribute("target") || "_blank"
  if (url) {
    window.open(url, target)
  }
}

StreamActions.analytics_track = function() {
  const event = this.getAttribute("event")
  const properties = this.getAttribute("properties")
  analytics.track(event, JSON.parse(properties))
}
